module.exports = __webpack_public_path__ + "static/calendar-8496380860b4dbc3ea2e1f648bbd07dc.png";